import { ContentStatus, useContentEntry } from '@soluto-home-web/platform-core';
import { BodyText, Heading1 } from 'packages/smart-home-support/components/Typography';
import { LinkId } from 'packages/smart-home-support/constants';
import { useAdobeAnalytics, useScrollResetter } from 'packages/smart-home-support/hooks';
import { Container } from 'packages/smart-home-support/pages/signup/components/Common';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';
import React from 'react';
import { useTweekValue } from 'react-tweek';
import styled from 'styled-components';
import { LoadingOverlay } from '../../components';
import RichText from '../../components/RichText';
import NeedHelpButton from '../profile/components/NeedHelpButton';
import FeesAndDeductiblesSection from './FeesAndDeductiblesSection';
import { DevicesPageContent } from './models';

const s = {
  PageTitle: styled(Heading1)`
    text-align: center;
    margin-top: 20px;

    @media ${BREAK_POINTS.desktop} {
      font-size: 45px;
    }
  `,
  Intro: styled(BodyText)`
    font-size: 18px;
    margin-top: 15px;
    margin-bottom: 35px;
    padding: 3% 5%;

    @media ${BREAK_POINTS.tablet} {
      padding: 1% 5%;
    }
  `,
  Buttons: styled.div`
    margin: 1em auto;
    width: fit-content;
  `,
};

const FeesAndDeductiblesPage: React.FC = () => {
  useScrollResetter();
  useAdobeAnalytics();

  const contentId = useTweekValue('soluto_home_web/smart_home_support/pages/fees_and_deductibles/content_id', '');
  const content = useContentEntry<DevicesPageContent>(contentId);

  return (
    <Container>
      <LoadingOverlay in={content.status === ContentStatus.loading} isFullPage />

      {content.status === ContentStatus.loaded && (
        <>
          <s.PageTitle>{content.data.fields.title}</s.PageTitle>
          <s.Intro>
            <RichText content={content.data.fields.description} />
          </s.Intro>
          {content.data.fields.sections.map((s) => (
            <FeesAndDeductiblesSection key={s.sys.id} {...s.fields} />
          ))}
        </>
      )}

      <s.Buttons>
        <NeedHelpButton id={LinkId.FeesAndDeductiblesNeedHelpCall} />
      </s.Buttons>
    </Container>
  );
};

export default FeesAndDeductiblesPage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/fees-and-deductibles/index.tsx